/* eslint-disable eqeqeq */
/* eslint-disable one-var */
/* eslint-disable no-var */
/* eslint-disable prettier/prettier */
import pushDataLayer from '~/mixins/gtm/push-data-layer'
import { STORE_CREDENTIALS } from '~/config'

export default ({ app, $userReady, $onUserConsent, $isBrStore }) => {
  const store = app.$storeCode
  const gtmID = STORE_CREDENTIALS[store]?.gtm?.id;
  const disableGtm = app.$config.disableGtm;

  const initGtm = () => {
    if (!gtmID || disableGtm) return;

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', gtmID);
      // eslint-disable-next-line no-console
      console.log('initing gtm.js', `| At time: ${performance.now()}`)
  }

  initGtm();

  app.router.afterEach((to, _from) => {
    const value = app.store.getters.sessionInfo
    value.isHomePage = (to.path === '/')
    value.path = to.path

    const event = {
      event: 'genericEvent',
      eventCategory: 'navigation',
      eventAction: 'pageView',
      eventValue: value,
    }

    pushDataLayer.methods.pushDataLayer(event)
    tiggerOnUserInteraction(event)
  })

  /**
   * Track user interaction event and send to GTM. Trigger once.
   */
  function tiggerOnUserInteraction(eventData) {
    const events = ['scroll', 'click', 'keyup', 'touchstart']

    events.forEach(event => {
      document.addEventListener(event, onIneraction, { once: true })
    })

    function onIneraction(e) {  
      const eventLabel = [
        eventData?.event || "{event}",
        eventData?.eventCategory || "{category}",
        eventData?.eventAction || "{action}",
        eventData?.eventLabel || "{label}"
      ].join(' - ')

      pushDataLayer.methods.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'userInteraction',
        eventAction: e.type,
        eventLabel,
        eventStore: eventData?.eventStore, 
        eventValue: eventData?.eventValue,
      });

      removeListeners()
    }

    function removeListeners() {
      events.forEach(event => {
        document.removeEventListener(event, onIneraction)
      })
    }
  }
}
